import React, { useState } from "react";
import { Button } from "react-bootstrap"
import * as AzureService from "../../../api/ticketsApiAzure";
import * as tConst from "../../../common/Constants";
import AddNew from "../AddNew";


const ChildrenMenuToolbar = ({ ...props }) => {
    const [showAddNew, setShowAddNew] = useState(false);

    if (!props.isLoaded) {
        return (<></>)
    }
    else {
        const numberOfChildren = props.children ? props.children.length : 0;
        return (
            <>
                <div>
                    {numberOfChildren > 0 && <h6>Children:</h6>}

                    {numberOfChildren > 0 && <Button variant="info" size="sm" onClick={() => {
                        PlanningToChildren(props.auth, props.selectedTicket, props.children);
                        props.onClose();

                    }}>Inherit</Button>}
                    &nbsp;
                    {numberOfChildren > 0 && <Button variant="info" size="sm" onClick={() => {
                        PlanningToChildren(props.auth, props.selectedTicket, props.children);
                        addChildrenToTimeline(props.auth, props.selectedTicket, props.children);
                        props.onClose();
                    }}>Add</Button>}
                    &nbsp;
                    <Button variant="info" size="sm" onClick={() => {
                        const _toggle = !showAddNew;
                        setShowAddNew(_toggle);
                    }}>New</Button>
                </div>
                <AddNew
                    showAddNew={showAddNew}
                    parent={props.selectedTicket}
                    auth={props.auth}
                    onClose={props.onClose}
                    onSetRefresh={props.onSetRefresh}
                    handleClose={() => {
                        setShowAddNew(false);
                    }}
                />

                <div>
                    <table className="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Title</th>
                                <th>Project</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>

                            {props.children.map((item) => (
                                <tr key={item.id}>
                                    <td>
                                        <a href={tConst.AZURE_DEVOPS_BASE_TICKET_URI + item.id} target="_blank" rel="noopener noreferrer">
                                            {item.id}</a>
                                    </td>
                                    <td>
                                        <a href={tConst.AZURE_DEVOPS_BASE_TICKET_URI + item.id} target="_blank" rel="noopener noreferrer">
                                            {item.fields[tConst.AF_TITLE]}</a>
                                    </td>
                                    <td>
                                        {item.fields[tConst.AF_PROJECT]}
                                    </td>
                                    <td>
                                        {item.fields[tConst.AF_STATE]}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </>
        )
    }

}

const PlanningToChildren = (auth, selectedTicket, children) => {
    const initiative = selectedTicket.fields[tConst.AF_INITIATIV];
    const PlanningPriority = selectedTicket.planningPri;
    const childrenIds = children.map(item => (item[tConst.AF_ID]));
    const _PlanningPriority = 0.1 + Number(PlanningPriority)

    console.log("initiative" + initiative + " / PlanningPriority: " + PlanningPriority + " / Children: " + JSON.stringify(childrenIds))

    const data = [
        { attribute: tConst.AF_INITIATIV, "value": initiative },
        { attribute: tConst.AF_PLANNING_PRIORITY, "value": _PlanningPriority }
    ]

    childrenIds.map((item) => {
        return AzureService.updateTicket(auth, item, data).then((response) => {
            console.log("Updated Ticket: " + JSON.stringify(response));
        })
    })
}

const addChildrenToTimeline = (auth, selectedTicket, children) => {
    const _missingChildren = children.filter(item => (!item.fields[tConst.AF_START_ITERATION] || !item.fields[tConst.AF_END_ITERATION]))
    const childrenIds = _missingChildren.map(item => (item[tConst.AF_ID]));

    const _start = new Date(selectedTicket.fields[tConst.AF_START_ITERATION]);
    const _end = new Date(selectedTicket?.fields[tConst.AF_END_ITERATION]);

    const data = [
        { attribute: tConst.AF_START_ITERATION, "value": _start },
        { attribute: tConst.AF_END_ITERATION, "value": _end }
    ]
    childrenIds.map((item) => {
        return AzureService.updateTicket(auth, item, data).then((response) => {
            console.log("Updated Ticket: " + JSON.stringify(response));
        })
    })
}


export default ChildrenMenuToolbar